Namespace 'Common'

class Common.DropDownBox extends Backbone.View
  template: JST['backbone/templates/common/drop_down_box']

  events:
    'click .drop-down-arrow': 'onDropDown'

  initialize: (headerView, footerView) ->
    @headerView = headerView
    @footerView = footerView
    @arrow = new Common.DropDownArrow()
    @isHidden = true

  onDropDown: ->
    return unless @footerView
    @$el.find('.drop-down-arrow').html(@arrow.toggleArrow().render().el)
    if @isHidden
      @$el.find('.footer-box').show()
    else
      @$el.find('.footer-box').hide()
    @isHidden = !@isHidden


  render: ->
    @$el.html(@template)
    @$el.find('.header-box').html(@headerView)
    @$el.find('.footer-box').html(@footerView)
    @$el.find('.footer-box').hide()
    @$el.find('.drop-down-arrow').html(@arrow.render().el) if @footerView
    @
